import { onScroll, scrollTop } from '../utils/scroll';

export function setupHeader() {
    const header = document.querySelector('.header');

    function enableAnimation() {
        document.body.classList.add('animate-header');
    }

    function setupHeaderAnimation(header) {
        const headerCampaignImage = header.querySelector('.header__campaign__image');

        if (headerCampaignImage) {
            if (headerCampaignImage.complete) {
                enableAnimation();
            } else {
                headerCampaignImage.addEventListener('load',enableAnimation);
                headerCampaignImage.addEventListener('error',enableAnimation);
            }
        } else {
            enableAnimation();
        }
    }

    function setupLargeHeader(header) {
        const headerImageWrap = header.querySelector('.header__image-wrap');

        if (headerImageWrap) {
            const height = header.offsetHeight;
            const width = headerImageWrap.offsetWidth;

            onScroll(() => {
                if (scrollTop <= height) {
                    /*
                        RP, 04-05-2022: This is pretty much like in the design - but actually a bit slower.
                        The customer actually wants is even slower, so we just slow it a bit down by changing the numbers we multiply by.
                    */
                    /*const newWidth = width + (scrollTop * 1.83);
                    const newY = (scrollTop * 1.5) * -1;*/
                    const newWidth = width + (scrollTop * 1.83);
                    const newY = scrollTop * -1;

                    const scale = newWidth / width;

                    // Removed old header transform due to keflico has trouble finding images
                    // const headerTransform = `translateZ(0) translateX(-50%) translateY(${newY}px) scale(${scale})`;
                    const headerTransform = `scale(${scale})`;

                    headerImageWrap.style.transform = headerTransform;
                }
            });
        }
    }

    function setupMediumHeader(header) {
        const headerImageWrap = header.querySelector('.header__image-wrap');
        const headerImage = header.querySelector('.header__image');

        if (headerImageWrap && headerImage) {
            const headerImageWrapBottom = headerImageWrap.getBoundingClientRect().top + headerImageWrap.offsetHeight;
            const headerImageBottom = headerImage.getBoundingClientRect().top + headerImage.offsetHeight;
            const width = headerImage.offsetWidth;
            const minWidth = headerImageWrap.offsetWidth;
            const minY = (headerImageBottom - headerImageWrapBottom) * -1;
            const maxY = 0;

            onScroll(() => {
                let newWidth = width - (scrollTop / 2);
                newWidth = newWidth > minWidth ? newWidth : minWidth;
                let newY = (scrollTop / 2) * -1;
                newY = newY > minY ? newY : minY;
                newY = newY < maxY ? newY : maxY;
                const scale = newWidth / width;

                newY = newY * scale;

                const headerImageTransform = `translateZ(0) translateX(-50%) translateY(${newY}px) scale(${scale})`;

                headerImage.style.transition = 'none';
                headerImage.style.transform = headerImageTransform;
            });
        }
    }

    if (header) {
        const isLarge = header.classList.contains('header-large');
        const isMedium = header.classList.contains('header-medium');

        if (isLarge) {
            setupLargeHeader(header);
        }

        if (isMedium) {
            setupMediumHeader(header);
        }

        setupHeaderAnimation(header);
    }
}
